//Quick View
$(document).ready(function () {
  quickView();
  quickAdd();
  var qvProductjson = '';
});

function quickAdd() {
  $(document).on("click", ".qv-add-button", function (event) {
    event.preventDefault();
    updateBtntext("loading");
    var selectedOptions = '';
    var qty = $('.qv-quantity').val();
    var perorder_pro = $('.qv-preorder-properties').val();
    var ddm_pro = $('.qv-ddm-properties').val();
    var var_id = '';
    $('#quick-view select').each(function (i) {
      if (selectedOptions == '') {
        selectedOptions = $(this).val();
      } else {
        selectedOptions = selectedOptions + ' / ' + $(this).val();
      }
    });


    if(perorder_pro){
      var properties = {
        preorder: "pre-order",
        DDM:ddm_pro
      };
    }else{
       var properties = {
      };
    }

      var var_id = ''
      $(qvProductjson.variants).each(function (i, v) {
        if (v.title == selectedOptions) var_id = v.id;
      });
      if(var_id != '') {
        jQuery.post('/cart/add.js', { quantity: qty,id: var_id, properties: properties},
          null,
          "json"
        ).done(function (data) {
          CartJS.updateItemById(var_id, data.quantity, properties);
          $("#cart-bar-model").trigger( "click" );
          $(".fancybox-close").trigger( "click" );
         // $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
		 $("html, body").animate({ scrollTop: 0 }, "slow");
        })
        .fail(function ($xhr) {
          var data = $xhr.responseJSON;
          $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
          updateBtntext();
        }); 
      }         
  });  
}
function quickView() {

  $(document).on("click",".quick-view",function() {
    //showQuickViewLoader();
    if (!$('.fancybox-overlay').length == 0){ $('.qv-product-images').slick('unslick');}
    if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
    var product_handle = $(this).data('handle');
    var product_property = $(this).data('property');

    $('#quick-view').addClass(product_handle);
    $('#quick-view').attr("data-qv-handle",product_handle);
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      if(product.id){
        qvProductjson = product;
        var title = product.title;
        var type = product.type;
        var price = 0;
        var original_price = 0;
        var images = product.images;
        var variants = product.variants;
        var options = product.options;
        var template_suffix = product.template_suffix;
        var template_tags = product.tags;
        var file_extension = 'svg';
        var assestURL = '//cdn.shopify.com/s/files/1/0022/5856/7228/t/138/assets/';
        closeFancyModel();


        var multiTags = template_tags;
        var checkTagString = "product-PREORDER";


        var url = '/products/' + product_handle;

        $('.qv-product-title').text(title);
        $('.qv-view-product').attr('href', url);

        if ($.inArray(checkTagString, multiTags) !== -1) {
          $('.qv-preorder-properties').attr('name', 'properties[preorder]');
          $('.qv-preorder-properties').attr('value', 'Pre-Order');

          $('.qv-ddm-properties').attr('name', 'properties[DDM]');
          $('.qv-ddm-properties').attr('value', product_property);
        } 

        var imageCount = $(images).length;
        var swiperScrollbarWidth = 100/imageCount;
        $(images).each(function (i, image) {
          if (i == imageCount - 1) {
            var image_embed = '<div><img src="' + image + '"></div>';
            image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
            $('.qv-product-images').append(image_embed);

            $('.qv-product-images').slick({
              'dots': true,
              'arrows': true,
              'respondTo': 'min',
              'useTransform': false
            }).css('opacity', '1');

          } else {
            image_embed = '<div><img src="' + image + '"></div>';
            image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
            $('.qv-product-images').append(image_embed);
          }
        });

        $("ul.slick-dots li").css("width",swiperScrollbarWidth+"%");

        // hide default variantes options
        $(options).each(function (i, option) {
          var opt = option.name;
          var selectClass = '.option.' + opt.toLowerCase();
          $('.qv-product-options').append('<div class="selector-wrapper js product-form__item hide option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="single-option-selector product-form__input option-' + i + ' option ' + opt.toLowerCase() + '" data-index="option'+i+'"></select></div>');
          $(option.values).each(function (i, value) {
            $('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
          });
        });


        // swatch
        if(template_suffix != "handbag" && variants.length > 1){
            $(options).each(function (i, option) {
              var opt = option.name;
              var selectClass = '.option.' + opt.toLowerCase();

              if(opt == "Colour" || opt == "Color"){
                var optionblockClass = 'color-opt hide';
              }else{
                var optionblockClass = 'sizes';
              }

              $('.qv-product-options').append('<div class="swatch clearfix '+optionblockClass+'" data-option-index="'+i+'"><ul class="option ' + opt.toLowerCase() + '"></ul></div>');
              $(option.values).each(function (j, value) {
                if(j == 0){
                  var checkradio = "checked";
                }else{
                  var checkradio = "";
                }

                if(opt == "Colour" || opt == "Color"){
                  var clrImgUrl = assestURL+value.toLowerCase().replace(/\//g, "-")+'.'+file_extension;
                  $('ul.option.' + opt.toLowerCase()).append('<li><div data-value="' + value + '" class="swatch-element '+ value +'  variant-"><input class="product-form__input" id="swatch-'+i+'-'+value+'" type="radio" name="option-'+i+'" value="'+value+'" '+checkradio+'><label for="swatch-'+i+'-'+value+'" style="background-image: url('+clrImgUrl+')";></label></div></li>');
                }else{
                    $('ul.option.' + opt.toLowerCase()).append('<li><div data-value="' + value + '" class="swatch-element '+ value +'  variant-"><input class="product-form__input" id="swatch-'+i+'-'+value+'" type="radio" name="option-'+i+'" value="'+value+'" '+checkradio+'><label for="swatch-'+i+'-'+value+'">' + value + '</label></div></li>');
                }

              });
            });
        }

        // get product colour swatches
        $.get(url, function (response) {
          var $productDetail = $('<div>' + response + '</div>').find('[data-section-type="product-template-slider"]');
          var $productDetailSwatches = $productDetail.find('.swatch-color-opt');
          var $productDetailSizeGuide = $productDetail.find('.size-care-popup');
        
          $(".qv-size-guide").append($productDetailSizeGuide); 

          if($productDetailSizeGuide){
            if(template_suffix != "handbag" && variants.length > 1 && options != "color" &&  options != "colour" ){
              $(".qv-sizeguide").html('<a href="javascript:;" class="size-care no-border">Size Guide</a>');
            }
          }

          $(".qv-clrswatches").append($productDetailSwatches);

          $(".qv-clrswatches .swatch-color-opt li").each(function (k, value) {
              var hndl = $(this).find('a').attr("href");
              $(this).find('a').attr("data-handle",hndl).addClass("quick-view");
          });

          $(".qv-clrswatches .swatch-color-opt li a").attr("href","javascript:;");

          $(".size-care, #size-care-close").click(function(){
            $(".size-care-popup").toggleClass('active');
             if ($('.size-care-popup.active').length > 0) {
              $(".slick-arrow").hide();
             }else{
              $(".slick-arrow").show();
             }
          });

         // quickView();
        });

        //hideQuickViewLoader();

        // Trigger swatch event
        if ($('.swatch :radio').length) {
          $('.swatch :radio').change(function() {
            var optionIndex = $(this).closest('.swatch').attr('data-option-index');
            var optionValue = $(this).val();
            console.log("optionIndex : "+optionIndex+" optionValue : "+optionValue)
            $(this).closest('.qv-swatch-block').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
          });
        }

        $(product.variants).each(function (i, v) {
          if (v.inventory_quantity == 0) {
            $('.qv-add-button').prop('disabled', true).val('Out of Stock');
            $('.qv-add-to-cart').hide();
            $('.qv-product-price').text('Out of Stock').show();
            return true
          } else {
            price = parseFloat(v.price / 100).toFixed(2);
            original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            var symbol = theme.moneyFormat.split('{')[0];
            var symbol = symbol.replace( /(<([^>]+)>)/ig, '');
            $('.qv-product-price').text(symbol + price);
            if (original_price > 0) {
              $('.qv-product-original-price').text(symbol + original_price).show();
            } else {
              $('.qv-product-original-price').hide();
            }
            $('select.option-0').val(v.option1);
            $('select.option-1').val(v.option2);
            $('select.option-2').val(v.option3);
            return false
          }
        });
      }
    }).fail(function(jqxhr, textStatus, error) {
      $(".qv-add-button").hide();
      $(".qv-view-product").hide();
      $('.qv404error').html('<h1>This color variants is not available.</h1>');
      setTimeout(function() { 
          $(".fancybox-close").trigger( "click" );
      }, 1000);
    });

    $(document).on("change", "#quick-view select", function () {
      $(".qv-add-to-cart-response").html('').removeClass('success').removeClass('error');
      var selectedOptions = '';
      $('#quick-view select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + $(this).val();
        }
      });
      
      //jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        $(qvProductjson.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var price = parseFloat(v.price / 100).toFixed(2);
            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            var v_qty = v.inventory_quantity;
            var v_inv = v.inventory_management;
            var symbol = theme.moneyFormat.split('{')[0];
            var symbol = symbol.replace( /(<([^>]+)>)/ig, '');
            $('.qv-product-price').text(symbol + price);
            $('.qv-product-original-price').text(symbol + original_price);
            if (v_inv == null) {
              $('.qv-add-button').prop('disabled', false).val('Add To Cart');
            } else {
              if (v.available == false) {
                $('.qv-add-button').prop('disabled', true).val('Out of Stock');
              } else {
                $('.qv-add-button').prop('disabled', false).val('Add To Cart');
              }
            }
          }
        });
      //});
    });

        



    var fancyBox = function() {
      var product_handle = $('#quick-view').attr('data-qv-handle');
      $.fancybox({
        href: '#quick-view',
        maxWidth: 700,
        maxHeight: 600,
        fitToView: true,
        width: '100%',
        height: '70%',
        scrolling : 'hidden',
        autoSize: false,
        closeClick: false,
        openEffect: 'none',
        closeEffect: 'none',
        'beforeLoad': function () {
        //  $('.fancybox-wrap').css('overflow', 'hidden !important');
        },
        'afterShow': function () {
          $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
            $('.qv-product-images').addClass('loaded');
          });
        },
        'afterClose': function () {
          $('#quick-view').removeClass().removeAttr().empty();
        }
        ,
        helpers : {
            overlay : {
                locked: false
            }
        }
      });
    }
   fancyBox();


  });

  updateBtntext = function(status) {
    if(status == 'loading') $(".qv-add-button").val("Adding..")
    else $(".qv-add-button").val("Add to cart")
    return true;
  }
};

function closeFancyModel(){
    $(document).on("click",".new-fancybox-close", function(){
      //hideQuickViewLoader();
      $(".fancybox-close").click();
    });
}

function showQuickViewLoader(){
  //$(".loader-img-box").css("visibility","visible");
}

function hideQuickViewLoader(){
  //$(".loader-img-box").css("visibility","hidden");
}

$(window).resize(function () {
  if ($('#quick-view').is(':visible')) {
    $('.qv-product-images').slick('setPosition');
  }
});
